import React from 'react';
import { Form } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import Select from 'react-select';
import { getNestedError } from '../../utils/formUtils'; 
import { genericSelectStyles } from '../../utils/formConstants'; 

const FormSelect = ({ name, label, control, errors, options, isMulti = false, isRequired = false, placeholder = "Select...", isClearable = !isMulti, ...props }) => ( // ✅ isClearable by default for single selects
    <Form.Group className="mb-4 text-start">
        <Form.Label className="form-label">{label} {isRequired && <span className="text-danger">*</span>}</Form.Label> 
        <Controller 
            name={name} 
            control={control} 
            render={({ field: { onChange, value, ref } }) => (
                <Select 
                    ref={ref} 
                    isMulti={isMulti} 
                    isClearable={isClearable} // ✅ Pass isClearable prop
                    options={options || []} 
                    value={
                        isMulti 
                            ? (Array.isArray(value) ? value : []) 
                            : (options?.find(c => c.value === (value?.value || value)) || null)
                    }
                    onChange={selectedOption => {
                        onChange(selectedOption);
                    }} 
                    placeholder={placeholder} 
                    styles={genericSelectStyles} 
                    menuPortalTarget={document.body} 
                    {...props}
                />
            )} 
        />
        {getNestedError(errors, name) && <div className="text-danger small mt-1">{getNestedError(errors, name)?.message}</div>}
    </Form.Group>
);

export default FormSelect;